module.exports = __webpack_public_path__ + "assets/ultimate-addons-for-elementor.6d765ab0.svg";